import { api } from '../api.js';
import { state } from '../state.js';
import { navigate, route } from '../router.js';
import { loadUserData } from '../bootstrap.js';

export const Login = {
  data() {
    return { login: '', password: '', invite: '', error: '', busy: false, register: false };
  },
  computed: {
    setup() { return state.needSetup; },
    // Код приглашения нужен только при регистрации и только если стенд
    // выставлен наружу: на своей машине регистрация никого не касается.
    needInvite() { return state.inviteRequired && (this.register || this.setup); },
    title() {
      if (this.setup) return 'Первый запуск';
      return this.register ? 'Регистрация' : 'Вход';
    },
    hint() {
      if (this.setup) return 'Пользователей ещё нет. Придумай логин и пароль — станешь первым.';
      return 'Память и записи у каждого свои.';
    },
  },
  methods: {
    async submit() {
      this.error = '';
      this.busy = true;
      try {
        const path = (this.register || this.setup) ? '/api/auth/register' : '/api/auth/login';
        const { user } = await api.post(path, {
          login: this.login, password: this.password, invite: this.invite,
        });
        state.user = user;
        state.needSetup = false;

        // Справочники и проекты грузим до перехода: иначе на /projects
        // селекты направления и грейда окажутся пустыми.
        //
        // Но переход после долгого ожидания обязан спросить, где человек уже
        // находится. Как только пользователь установлен, список проектов
        // рисуется сразу — и на холодном сервере, где справочники грузятся
        // секунды (там опрашиваются `codex --version` и `claude --version`),
        // человек успевает создать проект и уйти на его страницу. Запоздалый
        // переход выбрасывал его обратно в список.
        const from = route.path;
        await loadUserData({ force: true });
        if (route.path === from) navigate('/projects');
      } catch (e) {
        this.error = e.message;
      } finally {
        this.busy = false;
      }
    },
  },
  template: `
    <div class="gate">
      <form class="card" @submit.prevent="submit">
        <h1>{{ title }}</h1>
        <p class="sub">{{ hint }}</p>

        <div class="field">
          <label for="login">Логин</label>
          <input id="login" v-model="login" autocomplete="username" autofocus
                 placeholder="логин">
        </div>
        <div class="field">
          <label for="password">Пароль</label>
          <input id="password" v-model="password" type="password" placeholder="пароль"
                 :autocomplete="register || setup ? 'new-password' : 'current-password'">
        </div>

        <div class="field" v-if="needInvite">
          <label for="invite">Код приглашения</label>
          <input id="invite" v-model="invite" placeholder="спроси у того, кто дал ссылку">
        </div>

        <button class="primary" style="width:100%;margin-top:16px" :disabled="busy">
          {{ busy ? 'Секунду…' : (register || setup ? 'Создать аккаунт' : 'Войти') }}
        </button>

        <p class="err" v-if="error" style="margin-top:10px">{{ error }}</p>

        <p class="faint" style="margin-top:14px" v-if="!setup">
          <a href="#" @click.prevent="register = !register">
            {{ register ? 'У меня уже есть аккаунт' : 'Зарегистрироваться' }}
          </a>
        </p>
      </form>
    </div>`,
};
